import CustomSearchInput from "../components/CustomSearchInput";

document.addEventListener('DOMContentLoaded', () => {
    let registrationForm = document.querySelector('form.register-form')

    if (registrationForm) {
        new CustomSearchInput(registrationForm.cityId, {
            url: '/api/cities/paginate'
        })
        let streetSearchInput = new CustomSearchInput(registrationForm.streetId, {
                data() {
                    return {
                        cityId: registrationForm.cityId.value
                    }
                },
                url: '/api/streets/paginate',
            }),
            houseSearchInput = new CustomSearchInput(registrationForm.houseId, {
                data() {
                    return {
                        streetId: registrationForm.streetId.value
                    }
                },
                url: '/api/houses/paginate',
            })

        if (registrationForm.cityId.value) {
            streetSearchInput.enable()
            houseSearchInput.enable()
            registrationForm.apartments.removeAttribute('disabled')
        } else {
            streetSearchInput.disable()
            houseSearchInput.disable()
            registrationForm.apartments.setAttribute('disabled', 'disabled')
        }

        registrationForm.cityId.addEventListener('change', () => {
            if (registrationForm.cityId.value) {
                streetSearchInput.enable()
                houseSearchInput.enable()
                registrationForm.apartments.removeAttribute('disabled')
            } else {
                streetSearchInput.disable()
                houseSearchInput.disable()
            }

            streetSearchInput.reset()
            houseSearchInput.reset()
        })
        registrationForm.streetId.addEventListener('change', () => {
            houseSearchInput.reset()
        })
    }
})
